<template>
  <div>
    <BasicSkeleton :show-placeholder="showPlaceholder">
      <ais-instant-search
        :search-client="searchClient"
        :future="{ preserveSharedStateOnUnmount: true }"
        :index-name="indexName"
      >
        <ais-configure
          :hits-per-page.camel="limit"
          :filters="searchFilter"
        />
        <ais-hits :transform-items="hidePlaceholder">
          <template #default="{ items }">
            <slot :items="transformItems?.(items) ?? items" />
          </template>
        </ais-hits>
      </ais-instant-search>
      <template #placeholder>
        <slot name="placeholder" />
      </template>
    </BasicSkeleton>
  </div>
</template>

<script setup lang="ts">
import type { AisArticle } from '@expert/types';
import { AisConfigure, AisHits, AisInstantSearch } from 'vue-instantsearch/vue3/es';

interface Props {
  categoryIds?: Array<string>;
  limit?: number;
  transformItems?: (items: Array<AisArticle>) => Array<unknown>;
}

const props = withDefaults(defineProps<Props>(), {
  categoryIds: () => [],
  limit: 12,
  transformItems: (items: Array<AisArticle>) => { return items },
});

const searchClient = useNuxtApp().$searchClient('/api/search/ppm-category');
const indexName = useReactiveSearchCreds().reactiveBaseAppName;
const showPlaceholder: Ref<boolean> = ref(true);

const searchFilter = computed(() => {
  switch (props.categoryIds.length) {
    case 0:
      return '';
    case 1:
      return 'categories:' + props.categoryIds.at(0);
    default:
      return 'categories:(' + props.categoryIds.join(' OR ') + ')';
  }
});

const hidePlaceholder = (items) => {
  showPlaceholder.value = false;
  return items;
}
</script>

<style scoped></style>
